._addPanelCategorySearch_1qoxv_1 {
  position: relative;
  padding: 0 24px 1px; }

._addPanelCategorySearch_1qoxv_1._addPanelCategorySearchScrolled_1qoxv_5 {
  box-shadow: 0 2px 7px 0 #162d3d2a; }

._addPanelCategorySearch_1qoxv_1._addPanelCategorySearchScrolled_1qoxv_5 ._searchInputWrapper_1qoxv_8 {
  transform: translateY(-5px);
  margin-bottom: 9px; }

._addPanelCategorySearch_1qoxv_1 ._addPanelCategorySearchTitle_1qoxv_12 {
  opacity: 1;
  padding-top: 10px;
  max-height: 20px;
  overflow: hidden;
  transition-property: max-height, opacity;
  transition-duration: 300ms; }

._addPanelCategorySearch_1qoxv_1 ._addPanelCategorySearchTitle_1qoxv_12._addPanelCategorySearchTitleHidden_1qoxv_20 {
  opacity: 0;
  max-height: 0; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8 {
  width: 300px;
  height: 30px;
  display: flex;
  align-items: center;
  border-radius: 999px;
  margin: 10px 0 0;
  background-color: #fff;
  border: 1px solid #b1ddf8;
  padding: 0 6px 0 12px;
  box-sizing: border-box;
  transition: transform 150ms ease-in; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8._searchInputWrapperFocused_1qoxv_37, ._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8._searchInputWrapperWithQuery_1qoxv_37 {
  border-color: #7fccf7;
  box-shadow: inset 0 0 4px 0 rgba(42, 90, 130, 0.55); }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8 input {
  width: 100%;
  border: none;
  outline: none;
  background-color: transparent; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8:hover {
  background-color: #eaf7ff; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8 ._searchIcon_1qoxv_50 {
  display: flex;
  margin-right: 6px; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8 ._searchButtonWrapper_1qoxv_54 {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: none; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8 ._searchButtonWrapper_1qoxv_54._visibleButton_1qoxv_60 {
  display: block; }

._addPanelCategorySearch_1qoxv_1 ._searchInputWrapper_1qoxv_8 ._searchButtonWrapper_1qoxv_54 ._searchButton_1qoxv_54 {
  width: 18px;
  height: 18px;
  padding: 0;
  transition: background-color ease 300ms; }
